import React, { useState, useEffect } from 'react'
import ImageCard from '../atoms/ImageCard'
import { getUsersList } from '../../utils/API/getUsersList'
import Pagination from '../atoms/Pagination'
import { useSearchParams } from 'react-router-dom'
import ProjectListLoader from '../atoms/ProjectListLoader'
import { useDispatch } from 'react-redux'
import SearchFilterHeader from '../molecules/SearchFilterHeader'
import { Link } from 'react-router-dom'
import { UserName } from '../../utils/helper/getUserName'

const SeeAllUsers = () => {
  const pageSize = 20
  const dispatch = useDispatch()
  const [usersData, setUsersData] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const currentPage = Number(searchParams.get('page')) || 1
  const [searchItem, setSearchItem] = useState('')
  const [filterData, setFilterData] = useState(null)

  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  })

  const fetchUsers = async () => {
    try {
      setLoading(true)
      const response = await getUsersList(
        {
          currentPage,
          pagelimit: pageSize,
          pagelimit: pageSize,
          user_type: filterData?.user_type,
          status: filterData?.type,
          searchQuery: searchItem
        },
        dispatch
      )
      const data = response.data
      if (data) {
        setUsersData(data)
        let nextPage = data.length === pageSize
        let totalItems = nextPage
          ? pageSize * (currentPage + 1)
          : pageSize * (currentPage - 1) + data.length
        // console.log(totalItems, ' + totalItems')
        setPagination({
          totalItems: totalItems,
          totalPages: nextPage ? currentPage + 1 : currentPage
        })

        // if (currentPage > data.totalPages) {
        //   setSearchParams({ page: data.totalPages });
        // }
        // if (currentPage > data.totalPages) {
        //   setSearchParams({ page: data.totalPages });
        // }
      }
    } catch (error) {
      console.error('Error fetching user data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [currentPage, searchItem, filterData])

  return (
    <>
      <SearchFilterHeader
        heading={'Users'}
        seeAllUser={true}
        searchItem={searchItem}
        setSearchItem={setSearchItem}
        filterData={filterData}
        setFilterData={setFilterData}
      />
      {loading ? (
        <ProjectListLoader />
      ) : (
        <div className='bg-gray-100 h-full w-full p-5'>
          <div className='flex flex-wrap mx-auto'>
            {usersData.map(userData => {
              const projectImage =
                userData.user_type === 'buyer' ||
                userData.user_type === 'trader'
                  ? '/images/userimgone.png'
                  : '/images/userimgtwo.png'

              return (
                <div
                  key={userData.user_id}
                  className='bg-white w-72 mx-4 my-3 h-64 rounded-xl'
                >
                  <Link to={`/profile-description/${userData._id}`}>
                    <div className='relative capitalize'>
                      <ImageCard
                        classnames='w-full bg-cover h-24 rounded-xl'
                        userImage={projectImage}
                      />
                      <div className='absolute inset-0 flex items-center justify-center text-2xl font-bold text-white'>
                        {userData.user_type}
                      </div>
                    </div>
                    <div className='p-3'>
                      <p className='text-2xl text-black-700 text-start font-bold'>
                      {UserName(userData.name, 17)}
                      </p>
                      <div className=' flex pt-2'>
                        <img
                          src='/images/location-pin.svg'
                          alt='location icon'
                        />
                        <p className='text-xs font-semibold px-2'>
                          {userData.location}
                        </p>
                      </div>
                      <div>
                        <p className='text-[10px] text-blue-800 pt-2'>
                          Transaction Done -{' '}
                          {userData.no_of_transactions_completed}
                        </p>
                      </div>
                      <div className='flex pt-2 justify-between '>
                        <div className='flex '>
                          <p className='text-xs font-semibold text-blue-800'>
                            {' '}
                            Authenticity{' '}
                          </p>
                          <img
                            src='/images/blueInfo.svg'
                            alt='location icon'
                            className='mt-1 px-2'
                          />
                        </div>
                        <p className='text-blue-800 text-xs'>
                          {userData.authenticity?.toFixed(2)}%
                        </p>
                      </div>
                      <div className='pt-2'>
                        <div className='w-full bg-grey-300 mt-1 rounded-full '>
                          <div
                            className='h-3 rounded-full bg-blue-800'
                            style={{ width: `${userData.authenticity}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )
            })}
          </div>
        </div>
      )}
      <Pagination
        current={currentPage}
        total={pagination.totalItems}
        pageSize={pageSize}
        setCurrentPage={page => setSearchParams({ page })}
      />
    </>
  )
}

export default SeeAllUsers
